import React from 'react';
import { Link } from 'react-router-dom';
// import { SidebarItemProps } from '../../shared/types/SidebarItemProps';

const NetworkSidebarItem = ({ to, name }) => {
  return (
    <li className="s-sidebar__nav-link">
      {' '}
      <Link to={to} target="_self">
        <span className="mr-2">
          <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971010/Group_2.1.png" alt="img" />
        </span>
        {name}
      </Link>
    </li>
  );
};

export default NetworkSidebarItem;
